import { render, staticRenderFns } from "./SettingUpdateModal.vue?vue&type=template&id=1d70ce46&scoped=true&"
import script from "./SettingUpdateModal.vue?vue&type=script&lang=js&"
export * from "./SettingUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingUpdateModal.vue?vue&type=style&index=0&id=1d70ce46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d70ce46",
  null
  
)

export default component.exports